export default __webpack_public_path__ + "fa47548a0dde5bc41d1f4e79984535bf.png";